import React from "react";
import { deviceBundle } from "../data/deviceBundle";
export function ProductMockup({
  priority = false
}: {
  priority?: boolean;
}) {
  return <img className="device-bundle-mockup" src={deviceBundle} alt="Team Communication Ready complete guide, with five workshops, shown on an iMac-style desktop, with its five bonus PDF covers on three tablets and two phones." width={1536} height={1024} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} decoding="async" data-id="element-106" data-mp="2tig8sm86q5ct" />;
}